import { render, staticRenderFns } from "./searchStatistics.vue?vue&type=template&id=0b0a0f67&scoped=true"
import script from "./searchStatistics.vue?vue&type=script&lang=js"
export * from "./searchStatistics.vue?vue&type=script&lang=js"
import style0 from "./searchStatistics.vue?vue&type=style&index=0&id=0b0a0f67&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a0f67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0a0f67')) {
      api.createRecord('0b0a0f67', component.options)
    } else {
      api.reload('0b0a0f67', component.options)
    }
    module.hot.accept("./searchStatistics.vue?vue&type=template&id=0b0a0f67&scoped=true", function () {
      api.rerender('0b0a0f67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportCenter/searchStatistics.vue"
export default component.exports